import { useNavigate } from '@tanstack/react-router';
import { ListsOverviewScreen } from '@mrrmlab/feature-lists';

export function EinkaufenRoute() {
  const navigate = useNavigate();
  return (
    <ListsOverviewScreen
      typeFilter="shopping"
      onOpenList={(list) =>
        navigate({ to: '/lists/$listId', params: { listId: list.id } })
      }
    />
  );
}
